module.exports = __webpack_public_path__ + "static/aprosoja_mt_logo-f8614377759384536c3b6f86e5bed678.png";